module.exports = __webpack_public_path__ + "static/rehabilitartelogo-d03a94c5e3f2c2cecb0ec5c316ff7908.png";